import { render, staticRenderFns } from "./CbxLiabilityTypes.vue?vue&type=template&id=d0e6168a&"
import script from "./CbxLiabilityTypes.vue?vue&type=script&lang=ts&"
export * from "./CbxLiabilityTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports